import { render, staticRenderFns } from "./my-info.vue?vue&type=template&id=31403427&scoped=true&"
import script from "./my-info.vue?vue&type=script&lang=js&"
export * from "./my-info.vue?vue&type=script&lang=js&"
import style0 from "./my-info.vue?vue&type=style&index=0&id=31403427&lang=less&scoped=true&"
import style1 from "@/assets/less/i-switch.less?vue&type=style&index=1&id=31403427&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31403427",
  null
  
)

component.options.__file = "my-info.vue"
export default component.exports